import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import Modal from "../../../General/Modal/Modal";

type OwnProps = {};

type Props = OwnProps;

const SuccessLoginModal: React.FC<Props> = () => {
  return (
    <Modal>
      <div className="login__success">
        <FontAwesomeIcon
          className="login__success--icon"
          icon={["far", "sign-in"]}
        />
        <p className="login__success--text">登入成功</p>
      </div>
    </Modal>
  );
};

export default SuccessLoginModal;
